import React from "react";
import "../../../css/Home.css";
import { useLocation } from "react-router-dom";
import { NavLink } from "react-router-dom";
import useIsAuthenticated from "react-auth-kit/hooks/useIsAuthenticated";
import useAuthUser from "react-auth-kit/hooks/useAuthUser";

export default function RegisterNav({ color }) {
  const style = {
    active: `text-red-500 ${color}-600 uppercase font-bold`,
    inactive: `text-${color}-600 text-white uppercase font-bold`,
  };

  const isAuthenticated = useIsAuthenticated();
  const auth = useAuthUser();
  const role = auth?.user?.role;
  const isAthlete = role === "athlete";
  const location = useLocation();

  const isCoachRegisterPage = location.pathname === "/register/coach";

  return (
    <>
      {!isAthlete && isCoachRegisterPage && (
        <h2 className="text-white undefined-600 uppercase font-bold px-6 text-xl">
          {" "}
          Register
        </h2>
      )}
      {/* Info area */}
      {!isAthlete && isCoachRegisterPage && (
        <div className="alert flex flex-row items-center bg-blue-100 p-3 rounded border-b-2 border-blue-300 my-6 mx-6">
          <div className="alert-icon flex items-center bg-blue-100 border-2 border-blue-500 justify-center h-8 w-8 flex-shrink-0 rounded-full">
            <span className="text-blue-500">
              <svg fill="currentColor" viewBox="0 0 20 20" className="h-6 w-6">
                <path
                  fillRule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                  clipRule="evenodd"
                ></path>
              </svg>
            </span>
          </div>
          <div className="alert-content ml-4 w-full">
            <div className="alert-title font-semibold text-md text-blue-700">
              Have you already created your university profile?
            </div>
            <div className="alert-description text-sm text-blue-700">
              <a className="text-blue-700 hover:underline px-1" href="/sign-in">
                Sign In here
              </a>
            </div>
          </div>
        </div>
      )}

      <ul className="flex justify-between mb-2 mx-6" role="tablist">
        {!isAthlete && isCoachRegisterPage && (
          <li className="-mb-px mr-2 last:mr-0 flex-auto text-left">
            <NavLink
              className={({ isActive, isPending }) =>
                isPending ? "" : isActive ? style.active : style.inactive
              }
              to="/register/coach"
            >
              Coach Registration
            </NavLink>
          </li>
        )}

        {!isAuthenticated && (
          <li className="-mb-px mr-2 last:mr-0 flex-auto text-right hidden">
            <NavLink
              className={({ isActive, isPending }) =>
                isPending ? "" : isActive ? style.active : style.inactive
              }
              to="/sign-in"
            >
              Sign In
            </NavLink>
          </li>
        )}
      </ul>
    </>
  );
}
